"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useSidePanelBodyScroll = require("./hooks/useSidePanelBodyScroll");
var HBSidePanelBody = function HBSidePanelBody(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var _useSidePanelBodyScro = (0, _useSidePanelBodyScroll.useSidePanelBodyScroll)(),
    bodyContainerRef = _useSidePanelBodyScro.bodyContainerRef;
  return /*#__PURE__*/_react["default"].createElement(BodyContainer, {
    className: className,
    ref: bodyContainerRef
  }, children);
};
var _default = exports["default"] = HBSidePanelBody; // -------------------------------- Styles -------------------------------- //
var BodyContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBSidePanelBody__BodyContainer",
  componentId: "sc-i07s2a-0"
})(["flex:1;overflow-y:auto;padding:16px;"]);
//# sourceMappingURL=HBSidePanelBody.js.map